import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#1A3A3A] py-12 border-t border-teal-900" data-id="element-55">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-56">
        <div className="flex items-center gap-4" data-id="element-57">
          <img src="https://cdn.magicpatterns.com/uploads/9kPEnQk3qpn3pap79A2DDd/lisa_logo.jpg" alt="Cheers by Lisa Logo" className="w-12 h-12 rounded-full object-cover" data-id="element-58" />
          <div data-id="element-59">
            <h4 className="text-white font-serif text-xl" data-id="element-60">Cheers by Lisa</h4>
            <p className="text-teal-100/60 text-sm font-light" data-id="element-61">
              {t('footer.tagline')}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-6" data-id="element-62">
          <a href="https://www.instagram.com/cheersbylisa.events?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity duration-200" data-id="element-63">
            <svg width="0" height="0" className="absolute" data-id="element-64">
              <defs data-id="element-65">
                <linearGradient id="ig-grad-footer" x1="0%" y1="100%" x2="100%" y2="0%" data-id="element-66">
                  <stop offset="0%" stopColor="#f09433" data-id="element-67" />
                  <stop offset="25%" stopColor="#e6683c" data-id="element-68" />
                  <stop offset="50%" stopColor="#dc2743" data-id="element-69" />
                  <stop offset="75%" stopColor="#cc2366" data-id="element-70" />
                  <stop offset="100%" stopColor="#bc1888" data-id="element-71" />
                </linearGradient>
              </defs>
            </svg>
            <Instagram className="w-5 h-5" style={{
            stroke: 'url(#ig-grad-footer)'
          }} data-id="element-72" />
            <span className="sr-only" data-id="element-73">Instagram</span>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61576473615425" target="_blank" rel="noopener noreferrer" className="text-[#1877F2] hover:opacity-80 transition-opacity duration-200" data-id="element-74">
            <Facebook className="w-5 h-5" data-id="element-75" />
            <span className="sr-only" data-id="element-76">Facebook</span>
          </a>
          <a href="#" className="text-teal-100/60 hover:text-[#D4A843] transition-colors" data-id="element-77">
            <Mail className="w-5 h-5" data-id="element-78" />
            <span className="sr-only" data-id="element-79">Email</span>
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-8 pt-8 border-t border-teal-900/50 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-80">
        <p className="text-teal-100/50 text-sm font-light" data-id="element-81">
          &copy; {new Date().getFullYear()} {t('footer.rights')}
        </p>
        <div className="flex gap-4 text-sm text-teal-100/50 font-light" data-id="element-82">
          <a href="#" className="hover:text-teal-100 transition-colors" data-id="element-83">
            {t('footer.privacy')}
          </a>
          <a href="#" className="hover:text-teal-100 transition-colors" data-id="element-84">
            {t('footer.terms')}
          </a>
        </div>
      </div>
    </footer>;
}